var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMercari(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 41,
    viewBox: "0 0 187 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5929 40.5668V35.4593H40.7013V30.7188H52.9966V25.6836H40.7013V20.7112H53.5929V15.6057H35.1987V40.5675H53.5929V40.5668Z",
    fill: "#5E6DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1589 13.4538C81.9608 14.9091 82.8723 16.9362 82.8723 19.479C82.9242 22.7819 81.065 25.8153 78.1066 27.2536L83.5894 36.2337H77.3363L72.5031 28.3138H68.5547V36.2337H63.0508V11.276H73.3429C76.1089 11.276 78.4041 12.0088 80.1582 13.4538H80.1589ZM72.4417 16.3788H68.5547V23.2452H72.4417C75.7957 23.2452 77.4175 22.0649 77.4175 19.7594C77.4175 17.454 75.8367 16.3781 72.4417 16.3781V16.3788Z",
    fill: "#5E6DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.735 32.3836C108.081 34.6337 105.882 35.7772 103.191 35.7772C101.231 35.8263 99.334 35.0779 97.9305 33.7031C96.5182 32.3188 95.7998 30.4097 95.7998 28.03C95.7998 25.6502 96.5182 23.8162 97.9305 22.466C99.2459 21.1274 101.041 20.3803 102.911 20.3905C105.456 20.3502 107.856 21.5804 109.313 23.6743L109.411 23.8149L113.121 20.0112L113.042 19.9136C110.539 16.7963 107.214 15.2134 103.159 15.2134C99.4581 15.2134 96.3367 16.3992 93.8805 18.7701C91.4243 21.141 90.1587 24.2638 90.1587 28.1419C90.1587 32.0199 91.412 35.0956 93.8833 37.4365C96.3545 39.7774 99.5632 40.9564 103.321 40.9564C107.48 40.9564 110.876 39.3776 113.416 36.2596L113.493 36.1613L109.824 32.2533L109.735 32.3829L109.735 32.3836Z",
    fill: "#5E6DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.205 11.276H133.372L133.392 11.3647L143.064 36.2344H137.37L135.562 31.7627H125.95L124.181 36.2344H118.483L118.557 36.0427L128.204 11.276H128.205ZM127.801 26.8319H133.778L130.787 18.925L127.801 26.8319Z",
    fill: "#5E6DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.351 17.7829C169.15 19.2382 170.064 21.2639 170.064 23.8074C170.112 27.1097 168.25 30.139 165.289 31.5738L170.772 40.5662H164.52L159.686 32.645H155.738V40.5662H150.233V15.6051H160.536C163.302 15.6051 165.553 16.3276 167.351 17.7829ZM159.625 20.7113H155.738V27.5736H159.625C162.973 27.5736 164.597 26.3953 164.597 24.0892C164.597 21.7831 163.02 20.712 159.625 20.712V20.7113Z",
    fill: "#5E6DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.001 13.4388H184.469V36.2337H179.001V13.4388Z",
    fill: "#5E6DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.452 5.99176L180.979 0L187 2.54148L184.471 8.53256L178.452 5.99176Z",
    fill: "#5E6DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7961 24.7858L19.8331 11.276H25.4367V36.2344H19.9068V21.983H19.8427L14.5127 31.6167H10.9362L5.60355 21.9987H5.53532V36.2214H0V11.276H5.60355L12.6815 24.7858H12.7954H12.7961Z",
    fill: "#5E6DF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 40.9564,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercari);
export default __webpack_public_path__ + "static/media/Mercari.79b88c31ceb39d596b235f0b5946891a.svg";
export { ForwardRef as ReactComponent };